var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTissueEnhanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tissue enhanced") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 58,
    width: 14,
    height: 12,
    rx: 2,
    fill: "#42A5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44,
    width: 14,
    height: 26,
    rx: 2,
    fill: "#42A5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 14,
    height: 42,
    rx: 2,
    fill: "#e0e0e0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 10,
    width: 14,
    height: 60,
    rx: 2,
    fill: "#e0e0e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTissueEnhanced);
export default __webpack_public_path__ + "static/media/tissue_enhanced.fcf25604707592519504651d3bfa4200.svg";
export { ForwardRef as ReactComponent };